import { render, staticRenderFns } from "./campo-texto-editavel.vue?vue&type=template&id=1c6ae230"
import script from "./campo-texto-editavel.vue?vue&type=script&lang=js"
export * from "./campo-texto-editavel.vue?vue&type=script&lang=js"
import style0 from "./campo-texto-editavel.vue?vue&type=style&index=0&id=1c6ae230&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports